import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { getAllModules, getAllCourse, updateCourseSequenceNumber } from '../../services/CourseService';
import { toast } from 'react-toastify';
import Loader from '../../utility/Loader';

export default function EditCourseSequence() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({user: {first_name: ""}});
    const [course, setCourse] = useState([]);
    
    useEffect(() => {
        const userDetails = getUserDetails();
        if(userDetails.token === undefined){
            navigate('/login');
        }else{
            setUserDetails(userDetails);
            getAllCourseData(userDetails.token);
        }

    },[]);

    const getAllCourseData = async (token) => {
        setLoading(true);
        const courseData = await getAllCourse(token);
        if(courseData.error){
            return [];
        }else{
            let courseArray = [];
            for(let i=0;i<courseData.data.length; i++){
                    courseData.data[i]['new_course_seq_no'] = courseData.data[i]['course_seq_no'];
                    courseArray.push(courseData.data[i]);
            }
            setCourse(courseArray);
        }
        setLoading(false);
    };

    const handleValueChange = (e, pd) => {
        const { name, value } = e.target;
        setCourse((prevItems) =>
            prevItems.map((item) =>
                item.course_id === pd.course_id ? { ...item, new_course_seq_no: value } : item
            )
        );
    };

    const updateSequence = async () => {
        let objectToPost = [];
        for(let i=0; i<course.length; i++){
            if(course[i].new_course_seq_no !== undefined && parseInt(course[i].new_course_seq_no) > 0 && parseInt(course[i].new_course_seq_no) !== parseInt(course[i].course_seq_no)){
                objectToPost.push(course[i]);
            }
        }
        if(objectToPost.length > 0){
            let resp = await updateCourseSequenceNumber(userDetails.token, {updates: objectToPost});
            if(resp.error === false){
                await getAllCourseData(userDetails.token);
                toast.success("Sequence Number Updated!");    
            }else{
                toast.error("Some Error occurred!");
            }
        }else{
            toast.warn("Nothing to update yet!");
        }
        
    };

    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className='py-10 lg:px-12 px-6'>
                    <h3 className='text-2xl text-secondary inter-700 lg:hidden mb-6'>Edit Course Sequence</h3>
                    <div className='flex justify-between flex-wrap pb-5 mb-6 border-b-2 border-[#D0D0D0]'>
                        <div className='order-2 lg:order-1 lg:w-[12.5%]'>
                            <button onClick={() => navigate('/superadmin/managecourses')} type="button" className='bg-tertiary hover:bg-black flex items-center justify-center px-5 h-8 2xl:h-12 text-white inter-600 text-sm 2xl:text-base rounded-3xl lg:rounded-full transition duration-300 button-shadow w-full md:w-auto'>Back</button>
                        </div>
                        <div className='order-3 lg:order-3 lg:w-[12.5%] flex justify-end'>
                            <button onClick={() => updateSequence()} type="button" className='bg-secondary hover:bg-black flex items-center justify-center px-5 h-8 2xl:h-12 text-white inter-600 text-sm 2xl:text-base rounded-3xl lg:rounded-full transition duration-300 button-shadow w-full md:w-auto'>Update</button>
                        </div>
                    </div>
                    <div className='custom-table-wrap'>
                        <table className='w-full border border-[#D0D0D0]'>
                            <tr>
                                <th className='text-sm md:text-base leading-none inter-600 text-left p-3 border border-[#d0d0d0] bg-[#eee]'>Current Sequence</th>
                                <th className='text-sm md:text-base leading-none inter-600 text-left p-3 border border-[#d0d0d0] bg-[#eee]'>Course</th>
                                <th className='text-sm md:text-base leading-none inter-600 text-left p-3 border border-[#d0d0d0] bg-[#eee]'>New Sequence</th>
                            </tr>
                            {course.map((c, index) => (
                            <tr>
                                <td className='text-sm leading-none inter-400 text-left p-3 border border-[#d0d0d0]'>{c.course_seq_no}</td>
                                <td className='text-sm leading-none inter-400 text-left p-3 border border-[#d0d0d0]'>{c.course_code} - {c.course_name}</td>
                                <td className='text-sm leading-none inter-400 text-left p-3 border border-[#d0d0d0]'>
                                    <input type='number' name="new_course_seq_no" value={course[index].new_course_seq_no} onChange={(event) => handleValueChange(event, c)} placeholder='' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                </td>
                            </tr>
                            ))}
                        </table>
                    </div>
                    
                </div>
            )}
        </div>
    );
}